import { ModalContainer, SwitchAppButton } from "../../components";
import signupSuccessfulImage from "../../assets/images/signup-successful.png";

interface ISignUpWithInvitationCodeSuccessfulProps {
  isModalOpen: boolean;
  closeModal: () => void;
}

export const SignUpWithInvitationCodeSuccessfulModal = ({
  isModalOpen,
  closeModal,
}: ISignUpWithInvitationCodeSuccessfulProps) => {
  return (
    <ModalContainer
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      selectorPrimaryFocus="button.cds--btn--primary"
    >
      <div className="signup-success-modal col flex-container justify-content--center align-items--center">
        <img
          src={signupSuccessfulImage}
          alt="signup successful"
          className="signup-successful-image mb-5"
        />

        <h2 className="font-ctm--bold mt-5 mb-5">Signup Successful!</h2>

        <div className="flex-box flex-container col align-items--center justify-content--center">
          <span>
            You have successfully registered on SwitchApp. You have also been
            added to a team.
          </span>

          <h5 className="text-danger font-ctm--bold mt-5">
            Please login using your username and password
          </h5>
        </div>
      </div>
    </ModalContainer>
  );
};
